import SynthesesShell from "./SynthesesShell";
import SynthesesIntervenantsBoard from "./SynthesesIntervenantsBoard";

function SynthesesIntervenants() {
  return (
    <SynthesesShell
      active="intervenants"
      title="Suivi de financements • Intervenants"
      description="Vue consolidée des projets affectés à chaque intervenant et de leurs contrats projet."
    >
      <SynthesesIntervenantsBoard />
    </SynthesesShell>
  );
}

export default SynthesesIntervenants;
